module.exports = __webpack_public_path__ + "static/img/通过智能Agent高效采集，智能分类精准检索，数据洞察安全存储，合规保障.09f6b6ae.png";